import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0 size-full md:p-5',
    mapWrapper: 'relative size-full min-h-0',
    mapOverlay: 'pointer-events-none absolute inset-0 z-10 md:bg-white/40',
    tabs: 'mb-3 w-full rounded-none border-0 bg-white px-3 pt-3',
    tab: 'heading-s h-10 flex-1 rounded-none border-[1px] border-black',
    panelContent:
      'relative h-[calc(var(--viewport-dynamic-height)-106px)] max-h-[calc(var(--viewport-dynamic-height)-106px)] min-h-0 w-full',
    pickupPointSelector: 'absolute z-50',
    searchLocationField: 'on-all duration-300 ease-in-out',
    searchLocationFieldBtn:
      'absolute top-2 right-2 z-20 size-12 p-0 transition-all duration-300 ease-in-out',
    pickupPointSelectorOnly: 'px-3'
  },
  variants: {
    mobileView: {
      false: {
        searchLocationField:
          'absolute top-10 right-[calc(40px+var(--pickup-additional-offset,0px))] left-115 z-50 hidden lg:block xl:left-125 xl:pr-[52px]',
        searchLocationFieldBtn: 'hidden'
      },
      true: {
        searchLocationField:
          'absolute top-2 left-5 z-50 w-[calc(100%_-_100px)] max-w-[600px] origin-center scale-100 overflow-visible rounded-md bg-white opacity-100 shadow-md transition-all duration-300 ease-in-out',
        searchLocationFieldBtn: 'flex'
      }
    },
    size: {
      small: {
        pickupPointSelector: 'inset-y-4 left-4'
      },
      default: {
        pickupPointSelector: 'inset-y-10 left-6 xl:left-10'
      }
    },
    mobileViewField: {
      true: {
        searchLocationField: 'pointer-events-none opacity-0'
      },
      false: {}
    }
  }
});
